import bridgeRestaurant from 'mobx/bridge'
import { restaurantCenter, storeMobx } from 'restaurant'
import { locationMobx, memberMobx, themeMobx, authConfigMobx, giftCardMobx, thirdPartyMobx } from '@mobxStore'
import { addParams, store, ddayjs } from '@dt/fe-utils'
import { getPlatform, localStore } from '@utils'
import { wxConfigG } from 'controllers/third'
import languageMobx from '@mobx/app/language.mobx'
import mktController from 'controllers/mktController'
import wxpayGoldPlanController from 'controllers/wxpayGoldPlanController'
import { permissionMobx } from '@mobx/app'
import MSDK from 'sdk/monitor'

export default async function (homePageData: any, memberData: any, authRes: any) {
  const { BRANDID, STOREID, codeType, TABLECODE, buyTogetherId, queueId } = Config
  const { isWeixin, isWeixinMiniProgram, isAlipay, isAliPayMiniProgram, inMiniApp } = getPlatform()

  const initMSDK = () => {
    const userId = memberMobx.memberInfo?.memberId || localStore.get(`ls.visitor.${Config.BRANDID}`)?.id
    MSDK.init(userId)
  }
  // replace
  function replace (state, tt = '') {
    const url = tt ? addParams({ url: state + location.search, params: { tt } }) : state + location.search
    history.pushState({}, '', url)
  }

  await memberMobx.initMember(memberData)
  authConfigMobx.init('noWorry')
  initMSDK()

  // setConfig
  restaurantCenter.setConfig({
    brandId: BRANDID,
    storeId: STOREID || undefined,
    tableCode: TABLECODE || undefined,
    codeType: codeType || undefined,
    lbs: {
      lat: Config.LBS.latitude,
      lng: Config.LBS.longitude
    },
    language: i18n.language || store.get(`i18nextLng.${BRANDID}`) || 'en-US',
    buyTogetherId: String(buyTogetherId),
    queueId,
    app: 'mobile',
    displayMode: 'waterfall',
    otherType: Config.otherType || undefined,
    member: memberData && memberData?.member?.memberId ? {
      id: String(memberData.member.memberId),
      mobile: memberData.member.mobile,
      email: memberData.member.email,
      key: String(memberData.member.memberId),
      nickName: memberData.member.nickName,
      avatar: memberData.member.avatarUrl,
      openId: memberData.member.openId
    } : null,
    hideOpenPriceProduct: true,
    downSoldoutProduct: true,
    cityName: Config.cityName
  })

  // const history = useHistoryNew()
  let isInited = false
  const pathname = document.location.pathname
  const matchs = pathname.match(/^\/([^/]*)\/?/)
  const pathState = matchs ? matchs[1] : ''

  // 初始化三方券配置
  const initThirdParty = () => {
    if (window.boJudge.checkKey('thirdParty')) {
      /** 三方券 抖音券配置 */
      thirdPartyMobx.init()
    }
  }

  // 初始化定位数据
  const initLBS = async function (res?: any) {
    const lbs = res || Config.LBS
    if (lbs && lbs?.latitude && lbs?.longitude) {
      locationMobx.setLocationIsOpen(true)
      locationMobx.setLocation({
        ...lbs
      }, false)
      // TODO 20231031 门店分页暂时不上
      // 自带城市名称不需要从api获取
      // if (!Config.cityName) {
      // }
      locationMobx.getCityInfo({
        ...lbs
      })
    }
    return true
  }
  /** 初始化门店列表 */
  const initStore = async function (homePageData: any) {
    await storeMobx.initStoreScenes()
    storeMobx.initList(homePageData)
    return true
    // TODO 20231031 门店分页暂时不上
    // if (Config.codeType === 'brand') {
    //   return await storeMobx.initToCity(locationMobx.lbsCity || Config.cityName || '')
    // }
  }

  // 会员中心，能直接跳的页面
  const myCenterCanRefreshPages = ['/my/getCoupons', '/activity/wechatCoupons', '/luckyDraw', '/luckyDraw/detail', '/activity/bindMobile', '/activity/couponsGet', '/activity/couponsSend', '/my/couponGet', '/activity/consumeRebate', '/my/resetPwd', '/iRecord/flow', '/my/language', '/my/setting']
  const mktNotState = ['pointCard', 'giftCard', 'iGc', 'memberCard', 'iCard', 'iCoupon', 'groupBuy', 'redeem', 'login', 'mktResult', 'eval', 'activityReserve']
  // 不必要进过门店
  const notMustStore = ['mergeqr', 'mergeqrv2', 'posCheckout', 'posPayfail'].includes(pathState)
  // 商城页面
  const mallPage = ['mproduct', 'mcollect', 'mall'].includes(pathState)
  // 处理进入跳转逻辑
  const initEntry = async function () {
    isInited = true
    // console.log('screen.width ______', screen.width, pathname)
    document.querySelector('#ddloading')?.remove()
    if (authRes !== true) return
    // 页面刷新的时候，首次进入就变成了结果页，根据浏览器的缓存长度判断
    Config.firstState = history.length > 2 ? 'menu' : pathState
    // history.add
    if (!BRANDID) { // 链接无品牌，进入错误处理
      if (codeType === 'table') {
        replace('/goScan')
      } else {
        replace('/404')
      }
    } else if (['authAgreement'].includes(pathState)) {
    } else if (STOREID && !storeMobx.info.storeName && !notMustStore && !mallPage) {
      replace('/noStore')
      // const hasLbs = restaurantCenter.config?.lbs?.lat && restaurantCenter.config?.lbs?.lng
      // if (hasLbs) {
      //   replace('/store')
      // } else {
      //   replace('/noStore')
      // }
    } else if (!isAliPayMiniProgram && !isWeixinMiniProgram && screen.width > 1024 && !window.cordova && Config.source !== 'phoneCase') { // PC 打开
      window.prePage = location.href
      const searchParam = new URLSearchParams(location.search)
      if (pathState === 'paypalreturn') {
        searchParam.delete('token')
        searchParam.delete('PayerID')
      }
      const searchInfo = searchParam.toString()
      history.pushState({}, '', '/phoneCase?' + searchInfo)
    } else { // 正确链接进入'
      /** 商城授权过期 */
      const isMalllExpire = permissionMobx.getCheckMallExpire
      /** 单门店 */
      const isSingleStore = storeMobx.viewStoreList.length === 1
      const interceptHome = ((((BASECONFIG.openEnterHome || (!STOREID && BASECONFIG.openHome)) && (!pathState || pathState === 'menu')) || (BASECONFIG.openHome && !pathState)) && localStorage.getItem(`ls.needOpenScreen.${Config.BRANDID}`) !== 'false')
      if (!isWeixinMiniProgram && !isAliPayMiniProgram && !inMiniApp && interceptHome) {
        replace('/home')
      } else if (!notMustStore && !mallPage && (!storeMobx.storeList.length || !storeMobx.viewStoreList.length)) {
        // 前往个人中心的需要增加个人设置的入口
        replace('/noStore', pathState === 'my' && pathState)
        // const hasLbs = restaurantCenter.config?.cityName || restaurantCenter.config?.lbs?.lat && restaurantCenter.config?.lbs?.lng
        // if (hasLbs) {
        //   replace('/store')
        // } else {
        //   // 前往个人中心的需要增加个人设置的入口
        //   replace('/noStore', pathState === 'my' && pathState)
        // }
      } else if (isMalllExpire && ['mproduct', 'mcollect', 'mall'].includes(pathState)) {
        replace('/noMall')
      } else if (pathState === 'my' && pathname !== '/my' && !myCenterCanRefreshPages.some((page) => pathname.includes(page))) {
        replace('/my')
      } else if (pathname === '/my/language') {
        replace('/my/setting')
      } else if (myCenterCanRefreshPages.some((page) => pathname.includes(page))) {
        // 什么都不做
      } else if (pathState === 'login' && pathname !== '/login') {
        replace('/my')
      } else if (pathState === 'checkout' || pathState === 'cart' || pathState === 'visit') { // TODO 暂时先返回到点餐页
        replace('/menu')
      } else if (Config.buyTogetherId && !['result', 'billBuyTogether'].includes(pathState)) { // 带有拼单id初始化就进入拼单购物车,除了购物车
        replace('/buyTogetherCart')
      } else if (['my', 'pay', 'orders', 'store', 'home', 'menu', 'mall'].includes(pathState)) {
        const hasLbs = restaurantCenter.config?.cityName || restaurantCenter.config?.lbs?.lat && restaurantCenter.config?.lbs?.lng
        if (!storeMobx.info.storeId && !STOREID && !hasLbs && !isSingleStore && ['menu'].includes(pathState)) {
          replace('/store')
        } else {
          if (~pathname.indexOf('mproduct/') || ~pathname.indexOf('mpayfail')) {
            replace(pathname)
          } else {
            replace(pathname === '/orders/2' ? pathname : '/' + pathState)
          }
        }
      } else if (pathState === 'mcheckout') { // TODO 暂时先返回到商城页
        replace('/mall')
      } else if (['mproduct', 'mcollect'].includes(pathState)) {
        // 什么都不做
      } else if (['product', 'combo', 'mproduct'].includes(pathState) && pathname.split('/')?.length === 3) {
        // 什么都不做
      } else if (pathname === '/queue' && ['store'].includes(Config.codeType)) {
      } else if (~pathname.indexOf('storeDisplay/')) {
        replace('/storeDisplay')
        // 什么都不做
      } else if ([...mktNotState, 'result', 'payfail', 'bill', 'visit', 'paypalreturn', 'tempCard', 'billBuyTogether', 'weChatWork', 'jumpWx', 'advertBrand', 'recommend', 'storeDisplay', 'refund'].includes(pathState)) {
        // 什么都不做
      } else if (['mergeqr', 'mergeqrv2', 'posCheckout', 'posPayfail', 'authAgreement'].includes(pathState)) {
        // C扫B支付，会员扫码结算 什么都不做
      } else if (storeMobx.info.storeId) {
        replace('/menu')
      } else {
        replace('/store')
      }
    }
  }
  // 初始化restaurant相关的数据
  bridgeRestaurant(history)
  if (homePageData) {
    store.set(`ls.brandInfo.${homePageData.brandInfo.brandId}`, { brandId: homePageData.brandInfo.brandId, brandName: homePageData.brandInfo.brandName, logo: homePageData.brandInfo.logo })
    languageMobx.init(homePageData.brandInfo)
    themeMobx.setTemplateAdvert(homePageData.brandInfo, true)
    await initStore(homePageData)
    initThirdParty()
    if (homePageData.brandInfo?.timeZone) {
      ddayjs.setBrandTimezone(homePageData.brandInfo.timeZone as any)
      ddayjs.setStoreTimezone(homePageData.brandInfo.timeZone as any)
    }
    !!boJudge.checkKey('mall') && await permissionMobx.init('online_store')
    await permissionMobx.init('electronic_invoice')
    const isToError = storeMobx.storeList.find(v => v.saleTime === null)
    if (isToError) {
      replace('/systemError')
      document.querySelector('#ddloading').remove()
      return
    }
    // storeMobx.initCompliancePolicy()
    document.body.classList.add(BASECONFIG.backgroundMode)

    // 异常处理，超过6秒自动进入系统
    setTimeout(() => {
      if (!isInited) {
        initEntry()
      }
    }, 6000)

    if (isWeixin || isAlipay) {
      let wxConfigReady
      const hasLbs = restaurantCenter.config?.lbs?.lat && restaurantCenter.config?.lbs?.lng
      if (isWeixin) {
        if (!hasLbs) {
          wxConfigReady = await wxConfigG.init(async () => {
            mktController.openWechat = true
          }, () => {
            mktController.openWechat = false
          })
        } else {
          wxConfigG.init(async () => {
            mktController.openWechat = true
          }, () => {
            mktController.openWechat = false
          })
        }
      }
      let authLbs = !notMustStore
      const isAgreement = store.get(`ls.agreement.${BRANDID}`)
      if (isAgreement && ((isWeixin && !isWeixinMiniProgram && !hasLbs && wxConfigReady && authLbs) || (isAlipay && !isAliPayMiniProgram && !hasLbs && authLbs))) {
        const location = await locationMobx.getLocation().catch(error => {
          return error
        })
        if (location && !location?.error) {
          await initLBS(location)
        } else {
          await initLBS()
        }
      } else {
        await initLBS()
      }
    } else {
      await initLBS()
    }
    await initEntry()
    if (isWeixinMiniProgram) {
      const query = new URLSearchParams(location.search)
      const appId = query.get('appId')
      const authPhone = query.get('authPhone')
      const jsCode = query.get('jsCode')
      if (appId && authPhone && jsCode) {
        mktController.setWechatMiniappPhoneNumber(appId, authPhone, jsCode)
      }
    }
  } else {
    if (BRANDID && window.BUSYFLAG) {
      replace('/systemBusy')
    } else {
      if (!wxpayGoldPlanController.isOpen()) {
        if (codeType === 'table') {
          replace('/goScan')
        } else {
          replace('/404')
        }
      }
    }
    document.querySelector('#ddloading').remove()
  }
}
